// extracted by mini-css-extract-plugin
export default {"results-count":"styles_results-count__PIBUR","skeleton":"styles_skeleton__IbnGS","shimmer":"styles_shimmer__nHxw1"};